import { createSelector } from 'reselect';
import { getRequest } from './requestSelectors';
import { validationSchemaWithMarketConfig } from '../utils/validationSchemaUtils';
import { getIsSubmitted } from './formSelectors';
import { getMarketConfig } from './marketConfigSelector';
import { getFilters } from './filtersSelectors';

export const getCombinedRequestFiltersAsJS = createSelector(
  getRequest,
  getFilters,
  (request, filters) => ({
    ...request.toJS(),
    ...filters.toJS(),
  })
);

export const getValidationErrors = createSelector(
  getIsSubmitted,
  getCombinedRequestFiltersAsJS,
  getMarketConfig,
  (isSubmitted, requestAndFiltersAsJS, marketConfig) => {
    try {
      if (isSubmitted) {
        validationSchemaWithMarketConfig(marketConfig).validateSync(requestAndFiltersAsJS, {
          abortEarly: false,
          marketConfig,
        });
      }
      return null;
    } catch (validationErrors) {
      return validationErrors;
    }
  }
);

export const getErrorLabels = createSelector(
  getIsSubmitted,
  getValidationErrors,
  (isSubmitted, validationErrors) => {
    if (!validationErrors || !isSubmitted) {
      return [];
    }
    return validationErrors.errors;
  }
);

export const getHasErrors = createSelector(
  getErrorLabels,
  (intlErrors) => intlErrors.length > 0
);

export const getWarnings = createSelector(
  getErrorLabels,
  (errorLabels) => (
    errorLabels ? Object.values(errorLabels).filter((value) => value) : []
  )
);

export const getIsErrorByField = (fieldName) => createSelector(
  getValidationErrors,
  (validationErrors) => validationErrors
    && validationErrors.inner.some(({ path }) => path === fieldName
    )
);
